module.exports = __webpack_public_path__ + "img/logos.37bea63a.png";